{
  "name": "@graphorin/observability",
  "version": "0.15.1",
  "description": "Observability primitives for the Graphorin framework: typed AISpan tracer over OpenTelemetry, mandatory withValidation wrapper for every exporter, sensitivity-aware RedactionValidator with built-in PII / secret patterns, GenAI Semantic Conventions conformance helpers, OpenInference span-kind emission, structured logger with span correlation, append-only JSONL exporter for replay, sanitized replay primitives, hierarchical CostTracker, and a minimal inline eval runner alongside a zero-default telemetry stub.",
  "license": "MIT",
  "author": "Oleksiy Stepurenko",
  "homepage": "https://github.com/o-stepper/graphorin/tree/main/packages/observability",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/o-stepper/graphorin.git",
    "directory": "packages/observability"
  },
  "bugs": {
    "url": "https://github.com/o-stepper/graphorin/issues"
  },
  "keywords": [
    "graphorin",
    "ai",
    "agents",
    "framework",
    "observability",
    "tracing",
    "opentelemetry",
    "otel",
    "gen-ai",
    "openinference",
    "redaction",
    "pii",
    "cost-tracking",
    "replay",
    "evals",
    "logger"
  ],
  "type": "module",
  "sideEffects": false,
  "engines": {
    "node": ">=22.12.0"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./tracer": {
      "types": "./dist/tracer/index.d.ts",
      "default": "./dist/tracer/index.js"
    },
    "./redaction": {
      "types": "./dist/redaction/index.d.ts",
      "default": "./dist/redaction/index.js"
    },
    "./redaction/patterns": {
      "types": "./dist/redaction/patterns.d.ts",
      "default": "./dist/redaction/patterns.js"
    },
    "./redaction/imperative-patterns": {
      "types": "./dist/redaction/imperative-patterns.d.ts",
      "default": "./dist/redaction/imperative-patterns.js"
    },
    "./exporters": {
      "types": "./dist/exporters/index.d.ts",
      "default": "./dist/exporters/index.js"
    },
    "./gen-ai": {
      "types": "./dist/gen-ai/index.d.ts",
      "default": "./dist/gen-ai/index.js"
    },
    "./openinference": {
      "types": "./dist/openinference/index.d.ts",
      "default": "./dist/openinference/index.js"
    },
    "./cost": {
      "types": "./dist/cost/index.d.ts",
      "default": "./dist/cost/index.js"
    },
    "./replay": {
      "types": "./dist/replay/index.d.ts",
      "default": "./dist/replay/index.js"
    },
    "./eval": {
      "types": "./dist/eval/index.d.ts",
      "default": "./dist/eval/index.js"
    },
    "./logger": {
      "types": "./dist/logger/index.d.ts",
      "default": "./dist/logger/index.js"
    },
    "./telemetry": {
      "types": "./dist/telemetry/index.d.ts",
      "default": "./dist/telemetry/index.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist",
    "src",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsdown",
    "typecheck": "tsc --noEmit && tsc -p tsconfig.tests.json",
    "test": "vitest run",
    "lint": "biome check .",
    "clean": "rimraf dist .turbo *.tsbuildinfo"
  },
  "dependencies": {
    "@graphorin/core": "workspace:*"
  },
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "devDependencies": {
    "fast-check": "^3.23.0"
  },
  "peerDependencies": {
    "zod": "^3.23.0 || ^4.0.0"
  },
  "peerDependenciesMeta": {
    "zod": {
      "optional": true
    }
  }
}
